import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grant-access',
  templateUrl: './grant-access.component.html',
  styleUrls: ['./grant-access.component.scss']
})
export class GrantAccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
